import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=a508594c"
import script from "./data-list.js?vue&type=script&lang=js&external"
export * from "./data-list.js?vue&type=script&lang=js&external"
import style0 from "./data-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports